import axios from 'axios';
import {configApi} from './config';

const baseUrl = "https://recipe-vti-production.up.railway.app:443/api/v1/point";

export const createPointForUserApi = (userId, token) => {
    const config = configApi(token);
    return axios.post(`${baseUrl}`, {}, {params: {userId: Number(userId)}, headers: config.headers})
}

export const updatePointApi = (userId, token) => {
    const config = configApi(token);
    return axios.put(baseUrl, {}, {params: {userId}});
}